import { render, staticRenderFns } from "./BorderSection.vue?vue&type=template&id=faec0770"
import script from "./BorderSection.vue?vue&type=script&lang=js"
export * from "./BorderSection.vue?vue&type=script&lang=js"
import style0 from "./BorderSection.vue?vue&type=style&index=0&id=faec0770&prod&lang=scss"
import style1 from "./BorderSection.vue?vue&type=style&index=1&id=faec0770&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports